import { NameSummaryFormCL } from '@/components/slides/DataSummary/cl/SummaryForms/NameSummaryFormCL.tsx';
import { ContactSummaryFormCL } from '@/components/slides/DataSummary/cl/SummaryForms/ContactSummaryFormCL.tsx';
import { AddressSummaryFormCL } from '@/components/slides/DataSummary/cl/SummaryForms/AddressSummaryFormCL.tsx';
import { PersonalInfoSummaryFormCL } from '@/components/slides/DataSummary/cl/SummaryForms/PersonalInfoSummaryFormCL.tsx';
import { AncestrySummaryFormCL } from '@/components/slides/DataSummary/cl/SummaryForms/AncestrySummaryFormCL.tsx';

export const SummaryFormsCL = () => {
  return (
    <>
      <NameSummaryFormCL />
      <ContactSummaryFormCL />
      <AddressSummaryFormCL />
      <PersonalInfoSummaryFormCL />
      <AncestrySummaryFormCL />
    </>
  );
};
